export enum UnitTestEvaluationType {
    NONE = "none",
    EXISTS = "exists",
    DATA_MATCHES = "data_matches",
}
